import { Directive, HostListener, inject, input } from '@angular/core';
import { ToastService } from '@lassi/webapp-shared';

@Directive({
  selector: '[libFileSizeValidator]',
  standalone: true,
})
export class FileSizeValidatorDirective {
  maxSizeInMB = input.required<number>();

  private readonly toastService = inject(ToastService);

  @HostListener('change', ['$event'])
  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = Array.from(input.files ?? []);
    if (files.length === 0) return;

    const maxSizeInBytes = this.maxSizeInMB() * 1024 * 1024;
    const hasOversizedFiles = files.some((file) => file.size > maxSizeInBytes);
    if (hasOversizedFiles) {
      const errorMessage = `File(s) exceeds the maximum allowed size of ${this.maxSizeInMB()}MB.`;
      this.toastService.showErrorMessage(errorMessage);
      this.resetInput(input, event);
    }
  }

  private resetInput(input: HTMLInputElement, event: Event): void {
    input.value = '';
    event.stopPropagation();
    event.preventDefault();
  }
}
